import { Box, Typography, IconButton, Dialog, DialogTitle, DialogContent, Paper, MenuItem, Divider, Grid, Button } from "@mui/material";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSTextField from "../../../Components/TextBox/WSTextBox";


interface CardTopUpProps {
  open: boolean;
  onClose: () => void;
}

export const CardTopUp: React.FC<CardTopUpProps> = ({ open,onClose }) => {
    const { handleSubmit, control, register } = useForm();

  
  
  const onSubmit = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };
  return (
    <Dialog
    open={open}
        onClose={onClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          style: {
            backgroundColor: 'whitesmoke',
            width: '80vw',
          },
        }}
  >
    <form onSubmit={handleSubmit(onSubmit)}>      
    <DialogTitle  sx={{backgroundColor:"green"}}>
      <Grid display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" color={"white"}>Card Processing</Typography>
        <IconButton onClick={onClose}>
          <WSIcons.CloseIcon sx={{color:"white"}}/>
        </IconButton>
      </Grid>
    </DialogTitle>
    <DialogContent>
        <Grid container spacing={4} sx={{mt:1}}>
            <Grid item xs={12} sm={2}>
                <Typography>Card No</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
            <WSTextField
          label={""}
          {...register("cardno")}
          id="cardno"
          name="cardno"
          control={control}
          rules={{ required: true }}
        />
            </Grid>
            <Grid item xs={12} sm={1}>
                <WSIcons.CreditCardIcon/>
            </Grid>
            <Grid item xs={12} sm={1}>
                <WSIcons.SearchIcon/>
            </Grid>
            <Grid item xs={12} sm={4}>
            <Button
          variant="outlined"
          sx={{borderColor: "green", 
            color: "black",}}
        >
         Show Card Information
        </Button>
            </Grid>
        <Grid item xs={12}>
         <Typography variant="h6">Card Information</Typography>
        </Grid>
      <Grid container item xs={12} sm={8} alignItems="center" spacing={1}>
        <Grid item xs={12} sm={3}>
          <Typography>Owner Name</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("ownerName")}
            id="ownerName"
            name="ownerName"
            control={control}
            rules={{ required: true }}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Typography>Card Holder</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("cardholder")}
            id="cardholder"
            name="cardholder"
            control={control}
            rules={{ required: true }}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Typography>Card Template</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("cardtemplate")}
            id="cardtemplate"
            name="cardtemplate"
            control={control}
            rules={{ required: true }}
          />
        </Grid>
      </Grid>

      {/* Person Icon and Guest Image */}
      <Grid item xs={12} sm={4}>
        <Grid container spacing={1} direction="column" alignItems="center">
          <Grid
            sx={{
              border: "1px solid #ccc", 
              
              borderRadius: "8px", 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: 120, 
              height: 120, 
              mb: 2, 
            }}
          >
            <WSIcons.Person fontSize="large" />
          </Grid>
          <Typography>Guest Image</Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>

      <Grid item xs={12} sm={2}>
        <Typography>Balance</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
      <WSTextField
            label={""}
            {...register("balance")}
            id="balance"
            name="balance"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={3}>
      <Typography>--</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
      <WSTextField
            label={""}
            {...register("balance--")}
            id="balance--"
            name="balance--"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Point Balance</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
      <WSTextField
            label={""}
            {...register("pointbalance")}
            id="pointbalance"
            name="pointbalance"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={3}>
      <Typography>Limit</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
      <WSTextField
            label={""}
            {...register("limit")}
            id="limit"
            name="limit"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Discount</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
      <WSTextField
            label={""}
            {...register("discount")}
            id="discount"
            name="discount"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={3}>
      <Typography>Balance On Credit Limit</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
      <WSTextField
            label={""}
            {...register("balancecreditlimit")}
            id="balancecreditlimit"
            name="balancecreditlimit"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Status</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
      <WSTextField
            label={""}
            {...register("status")}
            id="status"
            name="status"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      </Grid>
        </Grid>
    
        </DialogContent>
        <Grid
  item
  sx={{
    backgroundColor: "#333",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  <Grid container spacing={2} alignItems="center" gap={3}>
    <Grid item>
      <WSIcons.GTranslateIcon sx={{ color: "white" }} />
    </Grid>
  </Grid>
  <Grid
    container
    item
    sx={{
      display: "flex",
      justifyContent: "flex-end",
    }}
    gap={2} // Adjust spacing between buttons
  >
    <Button
      variant="outlined"
      color="success"

    >
      Recharge
    </Button>
    <Button
      variant="outlined"
      color="success"

    >
      Add point
    </Button>
    <Button
      variant="outlined"
      color="success"

    >
      Refund
    </Button>
    <Button
      variant="outlined"
     color="success"
      
    >
       Refund Point
    </Button>
  </Grid>
</Grid>

      </form>
  </Dialog>
  );
};
